import { Link } from "react-router-dom"

import { InfoFrame, styled } from "@l2r-front/l2r-ui"

export const Info = styled(InfoFrame)(({ theme }) => ({
    marginBottom: theme.spacing(3),
}))

export const ErrorLink = styled(Link)(() => ({
    color: "inherit",
    textDecoration: "underline",
}))

export const EmptyText = styled("div")(({ theme }) => ({
    color: theme.palette["_components/alert/info/color"].main,
}))
